__turbopack_context__.v({
  "ratings-bar": "Q7ikuq_ratings-bar",
  "ratings-bar-inner": "Q7ikuq_ratings-bar-inner",
  "ratings-layout": "Q7ikuq_ratings-layout",
  "ratings-section": "Q7ikuq_ratings-section",
  "ratings-title": "Q7ikuq_ratings-title",
});
